/**
 * Formats a JavaScript Date object into the string "Wed, Jan 2022 4:30PM" format.
 * @param {Date} date - The Date object to be formatted.
 * @returns {string} A string representing the formatted date.
 */
const formatDate = (dateString: string): string => {
    if (!dateString) {
        return ''
    }
    const date = new Date(dateString)

    // Check if the date is invalid
    if (isNaN(date.getTime())) {
        return ''
    }

    const options: Intl.DateTimeFormatOptions = {
        // weekday: 'short',
        day: 'numeric',
        month: 'short',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
    }

    const dateTimeFormat = new Intl.DateTimeFormat('en-US', options)
    return dateTimeFormat.format(date)
}

export default formatDate
